type BrandLogoVariant = 'mark' | 'lockup';
type BrandLogoTone = 'light' | 'dark';
export type BrandLogoBrand = 'yrp-real-estate' | 'yrp-tucson';

interface BrandUser {
  email: string;
  name: string;
}

interface BrandLogoProps {
  variant?: BrandLogoVariant;
  tone?: BrandLogoTone;
  brand?: BrandLogoBrand;
  className?: string;
}

const YRP_BLUE_LOCKUP = '/brand/yrp-real-estate-long-blue-transparent.png';
const YRP_WHITE_LOCKUP = '/brand/yrp-real-estate-long-white-transparent.png';
const TUCSON_BLUE_LOCKUP = '/brand/YRP%20Tucson%20Logos/YRP%20Real%20Estate%20-%20Long%20-%20Tucson%20-%20Transparent%20Background.png';
const TUCSON_WHITE_LOCKUP = '/brand/YRP%20Tucson%20Logos/YRP%20Real%20Estate%20-%20Long%20-%20Tucson%20-%20White%20Logo%20-%20Transparent%20Background.png';
const BLUE_MARK = '/brand/yrp-real-estate-mark-blue-transparent.png';
const WHITE_MARK = '/brand/yrp-real-estate-mark-white-transparent.png';

export function brandForUser(user: BrandUser | null | undefined): BrandLogoBrand {
  const identity = `${user?.name ?? ''} ${user?.email ?? ''}`.toLowerCase();
  return identity.includes('iliana') || identity.includes('cacho')
    ? 'yrp-tucson'
    : 'yrp-real-estate';
}

function lockupForBrand(brand: BrandLogoBrand, tone: BrandLogoTone): string {
  if (brand === 'yrp-tucson') {
    return tone === 'dark' ? TUCSON_WHITE_LOCKUP : TUCSON_BLUE_LOCKUP;
  }
  return tone === 'dark' ? YRP_WHITE_LOCKUP : YRP_BLUE_LOCKUP;
}

export function BrandLogo({
  variant = 'lockup',
  tone = 'light',
  brand = 'yrp-real-estate',
  className,
}: BrandLogoProps) {
  const classes = ['brand-logo', `brand-logo-${variant}`, `brand-logo-${tone}`, `brand-logo-${brand}`, className]
    .filter(Boolean)
    .join(' ');
  // Alt text is the registered trade name in every market (a Tucson variant
  // of the name is not registered); the Tucson lockup image is unchanged.
  const alt = 'YRP Real Estate';

  return (
    <img
      className={classes}
      src={variant === 'mark' ? (tone === 'dark' ? WHITE_MARK : BLUE_MARK) : lockupForBrand(brand, tone)}
      alt={alt}
    />
  );
}
